(function() {
  'use strict';

  // Get settings from global vars (set in global_vars.liquid)
  var quickExitSettings = window.vars && window.vars.quickExit;
  
  // If no settings configured, exit
  if (!quickExitSettings || !quickExitSettings.pages || quickExitSettings.pages.length === 0) {
    return;
  }

  // Get neutral site URL from settings - reconstruct only when needed
  // URL is stored in parts to prevent browser prefetching/favicon association
  var getNeutralSiteUrl = function() {
    try {
      if (quickExitSettings.neutralSiteParts && Array.isArray(quickExitSettings.neutralSiteParts)) {
        // Reconstruct URL from parts (prevents browser from recognizing it as URL)
        return quickExitSettings.neutralSiteParts[0] + '://' + quickExitSettings.neutralSiteParts[1];
      }
    } catch (e) {
      // Fallback if reconstruction fails
    }
    return 'https://www.weather.com.au';
  };
  
  // Get configured pages (normalize to lowercase for comparison)
  var configuredPages = quickExitSettings.pages.map(function(page) {
    return page.toLowerCase().trim();
  }).filter(function(page) {
    return page.length > 0;
  });

  if (configuredPages.length === 0) {
    return;
  }

  /**
   * Check if current page should have quick exit functionality
   */
  function shouldEnableQuickExit() {
    // Get current page handle from URL (e.g., /pages/vulnerable-customers -> vulnerable-customers)
    var currentPath = window.location.pathname.toLowerCase();
    var pathParts = currentPath.split('/').filter(function(part) {
      return part.length > 0;
    });
    var currentHandle = pathParts[pathParts.length - 1] || '';
    
    // Get template suffix from body class (e.g., template_page_vulnerable_customers_land)
    var bodyClasses = document.body ? document.body.className.toLowerCase() : '';
    var templateSuffix = '';
    var templateMatch = bodyClasses.match(/template_page_([a-z0-9_]+)/);
    if (templateMatch) {
      templateSuffix = templateMatch[1];
    }
    
    // Check if current page matches any configured page (exact matches only)
    for (var i = 0; i < configuredPages.length; i++) {
      var configuredPage = configuredPages[i];
      
      // Exact match by page handle (URL slug)
      if (currentHandle === configuredPage) {
        return true;
      }
      
      // Exact match by template suffix
      if (templateSuffix === configuredPage) {
        return true;
      }
      
      // Also check if it's a page template and the handle matches
      // For pages like /pages/vulnerable-customers, check if handle matches
      if (pathParts.length >= 2 && pathParts[pathParts.length - 2] === 'pages' && currentHandle === configuredPage) {
        return true;
      }
    }
    
    return false;
  }

  /**
   * Handle quick exit functionality
   * Safari-specific: Use history.replaceState() first to properly replace history entry
   */
  function handleQuickExit() {
    // Get neutral site URL only when needed (prevents browser prefetching)
    var neutralSiteUrl = getNeutralSiteUrl();
    
    // Safari fix: First replace the history state, then navigate
    // This ensures Safari replaces the vulnerable page in history instead of creating new entry
    try {
      // Replace current history entry with neutral site URL
      // This works better in Safari than location.replace() alone
      window.history.replaceState(null, '', neutralSiteUrl);
      
      // Then navigate to complete the replacement
      window.location.replace(neutralSiteUrl);
    } catch (e) {
      // Fallback if replaceState fails
      window.location.replace(neutralSiteUrl);
    }
  }

  /**
   * Handle ESC key event - Safari compatible (MacBook Safari specific)
   */
  function handleEscKey(event) {
    // Check if ESC key is pressed (multiple checks for Safari compatibility)
    var isEscKey = false;
    
    // Modern browsers
    if (event.key === 'Escape' || event.key === 'Esc') {
      isEscKey = true;
    }
    // Legacy support (Safari sometimes uses keyCode)
    else if (event.keyCode === 27) {
      isEscKey = true;
    }
    // Additional Safari check
    else if (event.which === 27) {
      isEscKey = true;
    }
    // MacBook Safari specific: sometimes uses different key identifiers
    else if (event.code === 'Escape') {
      isEscKey = true;
    }
    
    if (isEscKey) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      handleQuickExit();
      return false;
    }
  }

  // Track if already initialized to prevent duplicate listeners
  var isInitialized = false;
  var stickyBarCreated = false;

  /**
   * Create and insert the sticky quick exit bar
   */
  function createStickyBar() {
    // Check if bar already exists
    if (document.getElementById('quick-exit-sticky-bar')) {
      return;
    }

    // Get customizable settings with fallbacks
    var barText = (quickExitSettings.barText || 'Need to exit this page quickly? Click here →');
    var buttonText = (quickExitSettings.buttonText || 'Quick exit');
    var barBgColor = (quickExitSettings.barBgColor || '#d70000');
    var barTextColor = (quickExitSettings.barTextColor || '#ffffff');
    var buttonBgColor = (quickExitSettings.buttonBgColor || '#ffffff');
    var buttonTextColor = (quickExitSettings.buttonTextColor || '#d70000');
    var buttonBorderColor = (quickExitSettings.buttonBorderColor || '#d70000');

    // Create the sticky bar container
    var stickyBar = document.createElement('div');
    stickyBar.id = 'quick-exit-sticky-bar';
    stickyBar.className = 'quick-exit-sticky-bar';
    // Apply bar background and text colors
    stickyBar.style.backgroundColor = barBgColor;
    stickyBar.style.color = barTextColor;
    
    // Create container wrapper (uses theme's container class)
    var containerWrapper = document.createElement('div');
    containerWrapper.className = 'container';
    
    // Create inner content wrapper
    var barContent = document.createElement('div');
    barContent.className = 'quick-exit-sticky-bar-content';
    
    // Create text element
    var textElement = document.createElement('span');
    textElement.className = 'quick-exit-sticky-bar-text';
    textElement.textContent = barText;
    textElement.style.color = barTextColor;
    
    // Create button element
    var buttonElement = document.createElement('button');
    buttonElement.className = 'quick-exit-sticky-bar-button';
    buttonElement.type = 'button';
    buttonElement.setAttribute('aria-label', buttonText);
    // Apply button colors
    buttonElement.style.backgroundColor = buttonBgColor;
    buttonElement.style.color = buttonTextColor;
    buttonElement.style.borderColor = buttonBorderColor;
    
    // Create exit icon (using SVG) - placed before button text
    var exitIcon = document.createElement('span');
    exitIcon.className = 'quick-exit-sticky-bar-icon';
    // SVG with currentColor for fill and stroke to match button text color
    exitIcon.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 3.625H12C13.3119 3.625 14.375 4.68814 14.375 6V8C14.375 8.20686 14.2069 8.375 14 8.375C13.7931 8.375 13.625 8.20686 13.625 8V6C13.625 5.10286 12.8971 4.375 12 4.375H5C4.10286 4.375 3.375 5.10286 3.375 6V18C3.375 18.8971 4.10286 19.625 5 19.625H12C12.8971 19.625 13.625 18.8971 13.625 18V16C13.625 15.7931 13.7931 15.625 14 15.625C14.2069 15.625 14.375 15.7931 14.375 16V18C14.375 19.3119 13.3119 20.375 12 20.375H5C3.68814 20.375 2.625 19.3119 2.625 18V6C2.625 4.68814 3.68814 3.625 5 3.625ZM17.7344 8.73535C17.8811 8.58912 18.1187 8.58847 18.2656 8.73438L21.2656 11.7344C21.3745 11.8443 21.4036 12.0053 21.3467 12.1426V12.1436C21.3268 12.1915 21.2994 12.2318 21.2656 12.2656L18.2656 15.2646C18.137 15.3928 17.939 15.4088 17.793 15.3125L17.7344 15.2646C17.589 15.1177 17.5883 14.8799 17.7344 14.7334L19.2402 13.2285L20.0938 12.375H7C6.79314 12.375 6.625 12.2069 6.625 12C6.625 11.7931 6.79314 11.625 7 11.625H20.0938L17.7344 9.26562H17.7354C17.5893 9.1191 17.589 8.88228 17.7344 8.73535Z" fill="currentColor" stroke="currentColor"/></svg>';
    // Icon uses button text color
    exitIcon.style.color = buttonTextColor;
    
    // Create button inner content
    var buttonTextElement = document.createElement('span');
    buttonTextElement.className = 'quick-exit-sticky-bar-button-text';
    buttonTextElement.textContent = buttonText;
    
    // Assemble button - icon before text
    buttonElement.appendChild(exitIcon);
    buttonElement.appendChild(buttonTextElement);
    
    // Assemble bar - container > content > text & button
    barContent.appendChild(textElement);
    barContent.appendChild(buttonElement);
    containerWrapper.appendChild(barContent);
    stickyBar.appendChild(containerWrapper);
    
    // Add click handler only to button
    var handleButtonClick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      handleQuickExit();
      return false;
    };
    
    buttonElement.addEventListener('click', handleButtonClick);
    
    // Insert into body
    if (document.body) {
      document.body.appendChild(stickyBar);
      stickyBarCreated = true;
    }
  }

  /**
   * Listen for ESC key press - Safari compatible with multiple event types
   */
  function initQuickExit() {
    // Check if this page should have quick exit enabled
    if (!shouldEnableQuickExit()) {
      return;
    }

    // Prevent duplicate initialization (only if already set up)
    if (isInitialized) {
      return;
    }
    isInitialized = true;

    // Create sticky bar
    if (!stickyBarCreated) {
      createStickyBar();
    }

    // Safari compatibility: Add multiple event listeners
    // Use capture phase to catch ESC key early (works better in Safari)
    var options = { capture: true, passive: false };
    
    // Primary: keydown event (works in Chrome, Firefox, most browsers)
    document.addEventListener('keydown', handleEscKey, options);
    
    // Safari fallback: keyup event (Safari sometimes misses keydown)
    document.addEventListener('keyup', handleEscKey, options);
    
    // Additional Safari fallback: keypress (older Safari versions)
    document.addEventListener('keypress', handleEscKey, options);
    
    // Window-level listener as ultimate fallback (Safari sometimes needs this)
    window.addEventListener('keydown', handleEscKey, options);
    window.addEventListener('keyup', handleEscKey, options);
    
    // MacBook Safari specific: Body-level listeners
    if (document.body) {
      document.body.addEventListener('keydown', handleEscKey, options);
      document.body.addEventListener('keyup', handleEscKey, options);
    }
    
    // MacBook Safari: Also try without capture phase
    var noCaptureOptions = { capture: false, passive: false };
    document.addEventListener('keydown', handleEscKey, noCaptureOptions);
    document.addEventListener('keyup', handleEscKey, noCaptureOptions);
  }

  // Initialize immediately if possible, otherwise wait for DOM
  // Safari sometimes needs earlier initialization
  if (document.readyState === 'loading') {
    // Try to initialize early for Safari
    if (document.body) {
      initQuickExit();
    }
    // Also wait for DOMContentLoaded as backup
    document.addEventListener('DOMContentLoaded', initQuickExit);
  } else {
    initQuickExit();
  }
  
  // Additional Safari fallback: Initialize on window load
  window.addEventListener('load', function() {
    // Re-initialize to ensure Safari catches the event
    initQuickExit();
    // Also ensure sticky bar is created if it wasn't already
    if (shouldEnableQuickExit() && !stickyBarCreated) {
      createStickyBar();
    }
  });
})();
